import React, { useMemo } from 'react'
import { NavLink, Outlet } from 'react-router-dom'
import type { TenantThemeConfig } from '../../types/theme'
import './historyGames.css'

interface AssetConfig {
  CDN_BASE_URL: string
  CSS_PATH: string
  IMG_PATH: string
  FONTS_PATH: string
}

export interface HistoryOutletContext {
  themeConfig: TenantThemeConfig
  assetConfig: AssetConfig
  getAssetUrl: (path: string) => string
}

interface ModernHistoryLayoutProps {
  themeConfig: TenantThemeConfig
  assetConfig: AssetConfig
}

/** Classic history shell for /history/games/* (full history hub not ported). */
const ModernHistoryLayout: React.FC<ModernHistoryLayoutProps> = ({ themeConfig, assetConfig }) => {
  const getAssetUrl = useMemo(() => {
    return (path: string) => {
      const base = assetConfig.CDN_BASE_URL || ''
      return base + (path.startsWith('/') ? path : `/${path}`)
    }
  }, [assetConfig.CDN_BASE_URL])

  const context: HistoryOutletContext = { themeConfig, assetConfig, getAssetUrl }

  return (
    <div className="content">
      <div className="container py-3">
        <nav className="mb-3" aria-label="ประวัติ">
          <NavLink to="/history/games" className="btn btn-sm btn-outline-secondary me-2">
            ประวัติเกมส์
          </NavLink>
        </nav>
        <Outlet context={context} />
      </div>
    </div>
  )
}

export default ModernHistoryLayout
